<template>
    <div class>
        <div class="page-cnt">
            <!-- Left sidebar -->
            <div class="left-sidebar ex-has-btm">
                <SearchTour
                    :groupType="groupType"
                    :listVouchers="listVouchers"
                    :setErrorMessage="setErrorMessage"
                    :updateTourInfo="updateTourInfo"
                    v-if="renderSearchTour">
                </SearchTour>

                <div class="content-wallet mt-4">
                    <!-- タブメニュー -->
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.BeforeContractScreenType}"
                                @click="switchScreen(constants.BeforeContractScreenType)"
                            >
                                <i class="icon-before-contract-red mr-2"></i>
                                {{$t('tab.before_handjob')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.AfterContractScreenType}"
                                @click="switchScreen(constants.AfterContractScreenType)"
                            >
                                <i class="icon-change-contract-red mr-2"></i>
                                {{$t('tab.after_handjob')}}
                            </a>
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link"
                                :class="{'active': screenType == constants.ConfirmContractScreenType}"
                                @click="switchScreen(constants.ConfirmContractScreenType)"
                            >
                                <i class="icon-confirm-contract-red mr-2"></i>
                                {{$t('tab.confirm')}}
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="mt-4 heading-breadcrumb" v-show="!isNotTour">
                    <div v-if="screenType == constants.BeforeContractScreenType">証憑明細登録 > 契約書 > 旅行契約(契約書類)</div>
                    <div v-else-if="screenType == constants.AfterContractScreenType">証憑明細登録 > 契約書 > 旅行契約(変更書類)</div>
                    <div v-else-if="screenType == constants.ConfirmContractScreenType">証憑明細登録 > 契約書 > 旅行契約(確定書類)</div>
                </div>

                <div class="warn-box" v-show="isNotTour">
                    <div class="header">
                        <i class="icon-warn"></i>
                    </div>
                    <div class="body">
                        <b>ツアー番号が未入力、もしくはツアーが存在しないか締切済みのため、契約書の取込が行えません。</b><br><br>
                        上部ツアー番号入力欄に改めてツアー番号を入力してから再度お試しください。
                    </div>
                </div>

                <div class="content-wallet" v-show="!isNotTour">
                    <!-- 手交時書面 -->
                    <div v-if="screenType == constants.BeforeContractScreenType">
                        <!-- 一括 -->
                        <div class="table-static" v-show="isBulkShow">
                            <div class="summary-contract" @click="openToggle(1)">
                                旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                                <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                            </div>
                            <transition name="bulk">
                                <div class="toggle" v-show="isBulkOpened">
                                    <div class="contract-sub-head">
                                        旅行条件書・旅程表・内訳書一括
                                        <i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_bulk.id, bulk ? bulk.id : '')"></i>
                                    </div>
                                    <div class="sub-cnt">
                                        <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                        <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <div class="table-static" v-show="isAloneShow">
                            <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                            <transition name="alone">
                            <div v-show="isAloneOpened">
                                <div class="sub-cnt">
                                    <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_conditions.id, condition ? condition.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_schedule.id, schedule ? schedule.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_items.id, item ? item.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                                </div>
                            </div>
                            </transition>
                        </div>

                        <!-- 旅行申込書 -->
                        <div class="table-static">
                            <div class="summary-contract">
                                {{ $t('contract.before.travel_apply') }}
                                <i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.contract_travel.id, apply ? apply.id : '')"></i>
                            </div>
                            <div class="mrgn-l-10">
                                <div class="no-data" v-if="utils.isEmptyObj(apply)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="apply" @detail="detailContract(apply.id)"></contract-row>
                            </div>
                        </div>

                        <!-- 旅行引受書 -->
                        <div class="table-static">
                            <div class="summary-contract">{{ $t('contract.before.travel_underwriting') }}<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.contract_underwriting.id, under ? under.id : '')"></i></div>
                            <div class="mrgn-l-10">
                                <div class="no-data" v-if="utils.isEmptyObj(under)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="under" @detail="detailContract(under.id)"></contract-row>
                            </div>
                        </div>

                        <!-- パンフレット -->
                        <div class="table-static">
                            <div class="summary-contract">{{ $t('contract.before.travel_pamphlet') }}<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.before_pamphlet.id, pamphlet ? pamphlet.id : '')"></i></div>
                            <div class="mrgn-l-10">
                                <div class="no-data" v-if="utils.isEmptyObj(pamphlet)">{{ $t('contract.no_data') }}</div>
                                <contract-row v-else :contract="pamphlet" @detail="detailContract(pamphlet.id)"></contract-row>
                            </div>
                        </div>
                    </div>

                    <!-- 手交後書面 -->
                    <div v-if="screenType == constants.AfterContractScreenType">
                        <!-- 一括 -->
                        <div class="table-static" v-show="isBulkShow">
                            <div class="summary-contract" @click="openToggle(1)">
                                旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                                <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                            </div>
                            <transition name="bulk">
                                <div class="toggle" v-show="isBulkOpened">
                                    <div class="contract-sub-head">旅行条件書・旅程表・内訳書一括<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_bulk.id, bulk ? bulk.id : '')"></i></div>
                                    <div class="sub-cnt">
                                        <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                        <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <div class="table-static" v-show="isAloneShow">
                            <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                            <transition name="alone">
                            <div v-show="isAloneOpened">
                                <div class="sub-cnt">
                                    <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_conditions.id, condition ? condition.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_schedule.id, schedule ? schedule.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.after_items.id, item ? item.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                                </div>
                            </div>
                            </transition>
                        </div>
                    </div>

                    <!-- 確定書面 -->
                    <div v-if="screenType == constants.ConfirmContractScreenType">
                        <!-- 一括 -->
                        <div class="table-static" v-show="isBulkShow">
                            <div class="summary-contract" @click="openToggle(1)">
                                旅行条件書・旅程表・内訳書 一括取込<i :class="isBulkOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i>
                                <div class="sub-title">※複合機で1ファイルにしている場合はこちら</div>
                            </div>
                            <transition name="bulk">
                                <div class="toggle" v-show="isBulkOpened">
                                    <div class="contract-sub-head">旅行条件書・旅程表・内訳書一括<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_bulk.id, bulk ? bulk.id : '')"></i></div>
                                    <div class="sub-cnt">
                                        <div class="no-data" v-if="utils.isEmptyObj(bulk)">{{ $t('contract.no_data') }}</div>
                                        <contract-row v-else :contract="bulk" @detail="detailContract(bulk.id)"></contract-row>
                                    </div>
                                </div>
                            </transition>
                        </div>

                        <div class="table-static" v-show="isAloneShow">
                            <div class="summary-contract" @click="openToggle(2)">旅行条件書・旅程表・内訳書 個別取込<i :class="isAloneOpened ? 'icon-minus' : 'icon-plus'" style="float:right"></i></div>
                            <transition name="alone">
                            <div v-show="isAloneOpened">
                                <div class="sub-cnt">
                                    <div class="head">旅行条件書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_conditions.id, condition ? condition.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(condition)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="condition" @detail="detailContract(condition.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行日程表<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_schedule.id, schedule ? schedule.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(schedule)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="schedule" @detail="detailContract(schedule.id)"></contract-row>
                                </div>

                                <div class="sub-cnt">
                                    <div class="head">旅行内訳書<i class="icon-camera-black" @click="setVoucherType(constants.VoucherType.confirm_items.id, item ? item.id : '')"></i></div>
                                    <div class="no-data" v-if="utils.isEmptyObj(item)">{{ $t('contract.no_data') }}</div>
                                    <contract-row v-else :contract="item" @detail="detailContract(item.id)"></contract-row>
                                </div>
                            </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /Left sidebar -->

            <!-- Main content -->
            <div class="main-cnt">
                <div class="content-white">
                    <TourInfo :setErrorMessage="setErrorMessage" :tourInfoProp="tourInfo"></TourInfo>
                    <div class="error-message-voucher" v-if="errorMessage">
                        <div class="d-flex">
                            <i class="icon-warning mr-2"></i>
                            <div class="errror-txt">
                                <p class="fs-14 text-red font600">{{$t('error.title')}}</p>
                                <p class="fs-14 text-red font600">{{ errorMessage }}</p>
                            </div>
                        </div>
                    </div>

                    <!-- preview File -->
                    <div class="content-body" v-if="previewFileUpload">
                        <preview-file-upload
                            :selectFiles="selectFiles"
                            :modeAddVoucher="goAddVoucher"
                            :cancelUpload="reset"
                            :uploadFiles.sync="uploadFiles"
                            :showThumb="showThumb"
                            :setErrorMessage="setErrorMessage"
                            :voucherType="voucherType"
                            :key="num"
                        ></preview-file-upload>
                    </div>

                    <!-- voucher Details -->
                    <div class="content-body" v-if="modeDetails">
                        <div class="d-flex">
                            <button class="btn btn-pink-53 w140 mr-3" @click="editVoucher">
                                <i class="icon-edit-w mr-2"></i>
                                {{$t('button.edit')}}
                            </button>
                            <button class="btn btn-gray-53 w140" data-toggle="modal" data-target="#modalDelete" v-show="utils.isAdmin() || !isCheckined" :disabled="utils.isReadOnly()">
                                <i class="icon-trash mr-2"></i>
                                {{$t('button.delete')}}
                            </button>
                        </div>
                        <component v-bind:is="componentDetailsVoucher" :voucher="voucher" :history="history" @successForceDelete="successForceDelete"></component>
                    </div>

                    <!-- add Voucher -->
                    <div class="content-body" v-if="modeAdd">
                        <component
                            v-bind:is="componentAddVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            :modeEdit="modeEdit"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                            @showPreInputCopyModal="showPreInputCopyModal"
                            ref="addComponent"
                        ></component>
                    </div>

                    <div class="content-body" v-if="modeEdit">
                        <component
                            v-bind:is="componentEditVoucher"
                            :setErrorMessage="setErrorMessage"
                            :voucherParams="voucherParams"
                            :modeEdit="modeEdit"
                            @voucherSuccess="voucherSuccess"
                            @cancelAdd="reset"
                        ></component>
                    </div>
                </div>

            </div>
        </div>

        <!-- Modal show thumb file -->
        <show-img :setListFiles="setListFiles" :file="file"></show-img>

        <upload-file-modal
            :previewFiles="previewFiles"
            :setListFiles="setListFiles"
            :uploadFiles="uploadFiles"
            :beforeCnt="beforeCnt"
        ></upload-file-modal>

        <DeleteVoucher
            :id="voucher.id"
            :getCashDetails="detailContract"
            :listVouchers="listVouchers"
            :groupType="groupType"
            :setErrorMessage="setErrorMessage"
            :reset="allReset"
        ></DeleteVoucher>

        <pre-input-copy
            @setVoucher="setVoucher"
            ref="preInputCopy"
        ></pre-input-copy>

    </div>
</template>

<script>
import { Constants } from "@/helpers/constants";
import Utils from "@/helpers/utils";
import DateUtils from '@/helpers/dateUtils';

import StorageService from "@/services/common/storage.service";
import VoucherService from "@/services/module/voucher.service";
// import CashService from "@/services/module/cash.service";
// import { AuthService } from '@/services/common/auth.service';

import TourInfo from "@/views/layout/pc/Tour/Info";
import SearchTour from "@/views/layout/pc/Tour/Search";
import UploadFileModal from "@/views/components/pc/Voucher/UploadFileModal";
import ShowImg from "@/views/components/pc/Voucher/ShowImg";
import PreviewFileUpload from "@/views/components/pc/Voucher/PreviewFileUpload";
import PreInputCopy from "@/views/components/pc/Voucher/PreInputCopy";
import DeleteVoucher from "@/views/components/pc/Voucher/DeleteVoucher";
import ContractRow from "@/views/components/common/ContractRow";

export default {
    components: {
        SearchTour,
        UploadFileModal,
        ShowImg,
        DeleteVoucher,
        PreviewFileUpload,
        TourInfo,
        PreInputCopy,
        ContractRow,
    },
    name: "PcContracts",
    data () {
        return {
            constants: Constants,
            utils: Utils,
            dateUtils: DateUtils,
            renderSearchTour: true,
            groupType: Constants.GroupVoucherType.travel_contract,
            screenType: Constants.BeforeContractScreenType,
            tourInfo: {},
            file: "",
            uploadFiles: [],
            previewFileUpload: false,
            voucherType: "",
            errorMessage: "",
            num: 0,

            // 各契約書リスト・先頭アイテム
            condition: {},
            schedule: {},
            apply: {},
            under: {},
            item: {},
            pamphlet: {},
            bulk: {},

            modeAdd: false,
            modeDetails: false,
            modeEdit: false,
            voucher: {},
            voucherParams: {},
            ocrData: "",
            contractId: "",
            history: [],
            isBulkOpened: false,
            isAloneOpened: false,
            isBulkShow: true,
            isAloneShow: true,
            isCheckined: false,
            isNotTour: false,

            beforeCnt: 0,
        };
    },
    computed: {
        componentDetailsVoucher: {
            get: function () {
                if (this.modeDetails) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );

                    StorageService.saveVoucherType(this.voucher.voucher_type_id);
                    if (!Utils.isEmptyStr(templateId)) {
                        return () =>
                            import(
                                `../Voucher/Details/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeDetails = newValue;
            },
        },
        componentAddVoucher: {
            get: function () {
                if (this.modeAdd) {
                    this.voucherParams = {};
                    if (!Utils.isEmptyStr(this.contractId)) {
                        this.voucherParams.id = this.contractId;
                    }
                    let templateId = Utils.getTemplateId(this.voucherType);
                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams.voucherTypeId = this.voucherType;
                        this.voucherParams.modeAdd = this.modeAdd;
                        let filePath = "";
                        if (this.ocrData.path) {
                            filePath = this.ocrData.path;
                        }
                        this.voucherParams.filePath = filePath;
                        let signature = false;
                        if (this.ocrData.signature) {
                            signature = this.ocrData.signature;
                        }
                        this.voucherParams.signature = signature;
                        if (!Utils.isEmptyObj(this.ocrData.ocr) && !Utils.isEmptyObj(this.ocrData.ocr.mapping)) {
                            let data = this.ocrData.ocr.mapping.template_mapping;
                            if (
                                data.transaction_date &&
                                data.transaction_date[0]
                            ) {
                                this.voucherParams.transactionDate = new Date(
                                    data.transaction_date[0]
                                );
                            }
                        }

                        StorageService.saveVoucherType(this.voucher.voucher_type_id);
                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeAdd = newValue;
            },
        },
        componentEditVoucher: {
            get: function () {
                if (this.modeEdit) {
                    let templateId = Utils.getTemplateId(
                        this.voucher.voucher_type_id
                    );

                    if (!Utils.isEmptyStr(templateId)) {
                        this.voucherParams = {};
                        this.voucherParams.id = this.voucher.id;
                        this.voucherParams.voucherNumber = this.voucher.voucher_number;
                        this.voucherParams.tourNumber = this.voucher.tour_number;
                        this.voucherParams.travelGroupName = this.voucher.travel_group_name;
                        this.voucherParams.docId = this.voucher.doc_id;
                        this.voucherParams.voucherTypeId = this.voucher.voucher_type_id;
                        this.voucherParams.voucherTypeName = this.voucher.voucher_type_name;
                        this.voucherParams.transactionDate = new Date(
                            this.voucher.transaction_date
                        );
                        this.voucherParams.use = this.voucher.use;
                        this.voucherParams.voucherName = this.voucher.voucher_name;
                        this.voucherParams.personInCharge = this.voucher.person_in_charge;
                        this.voucherParams.note = this.voucher.note;

                        return () =>
                            import(
                                `../Voucher/Add/Temp_` + templateId + `.vue`
                            );
                    }
                }
                return null;
            },
            set: function (newValue) {
                this.modeEdit = newValue;
            },
        },
    },
    beforeMount () {
        this.screenType = !Utils.isEmptyStr(this.$route.query.screenType) ? this.$route.query.screenType : 4;
        this.tourInfo = JSON.parse(StorageService.getTour());
        this.listVouchers();
    },
    methods: {
        setErrorMessage () {
        },
        // ツアー検索後処理(証憑検索)
        listVouchers () {
            this.reset();
            return VoucherService.contracts(this.screenType).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.formatContracts(response.data)
                    } else {
                        this.listVoucher = [];
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch (err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },
        // 再検索
        updateTourInfo (tour){
            this.allReset();
            this.forceRerenderSearchTour();
            this.tourInfo = tour;
            this.isNotTour = Utils.isEmptyObj(this.tourInfo);
        },

        forceRerenderSearchTour () {
            this.renderSearchTour = false;
            this.$nextTick(() => {
                this.renderSearchTour = true;
            });
        },

        // 証憑詳細表示
        detailContract (id) {
            this.reset();
            VoucherService.details(id).then(response => {
                if (response.status == 423) {
                    StorageService.saveExpired();
                    AuthService.doLogout();
                } else if (response.status != 200) {
                    const errCode = Utils.getErrorCode(response);
                    if (errCode) {
                        const msg = this.$root.$t("error.error_code_" + errCode);
                        this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
                    }
                } else {
                    if (!Utils.isEmptyObj(response.data)) {
                        this.modeDetails = true;
                        this.modeEdit = false;
                        this.component = this.modeDetails;
                        this.voucher = response.data;
                        this.history = response.data.history;
                        if (!Utils.isEmptyObj(this.history)) {
                            this.isCheckined = true;
                        } else {
                            this.isCheckined = false;
                        }

                        this.voucherTypeId = this.voucher.voucher_type_id;
                        this.setErrorMessage("");
                    } else {
                        let msg = this.$root.$t("general.no_data");
                        this.$toasted.success(msg, {});
                    }
                }
            }).catch (err => {
                this.errorMessage = this.$root.$t("error.error_unknown");
            });
        },

        formatContracts (data) {
            this.apply = data.apply ? data.apply : {};
            this.under = data.under ? data.under : {};
            this.condition = data.condition;
            this.schedule = data.schedule;
            this.item = data.item;
            this.pamphlet = data.pamphlet;
            this.bulk = data.bulk;

            if (this.checkAloneContract()) {
                this.isAloneOpened = true;
                this.isBulkShow = false;
            } else if (!Utils.isEmptyObj(this.bulk)) {
                this.isBulkOpened = true;
                this.isAloneShow = false;
            }
        },
        checkAloneContract() {
            return !Utils.isEmptyObj(this.condition) || !Utils.isEmptyObj(this.schedule) || !Utils.isEmptyObj(this.item);
        },
        editVoucher () {
            this.modeDetails = false;
            this.modeEdit = true;
        },
        // カメラアイコン(証憑取込) start
        setVoucherType (type, id = "") {
            this.reset();
            this.voucherType = type;
            if (!Utils.isEmptyStr(id)) {
                this.contractId = id;
            } else {
                this.contractId = "";
            }
            this.selectFiles();
        },
        selectFiles () {
            this.beforeCnt = this.uploadFiles.length;
            $("#uploadFileModal").modal("show");
        },
        setListFiles (files) {
            this.uploadFiles = files;
        },
        showThumb (file) {
            this.file = file;
            $("#ShowImg").modal("show");
        },
        previewFiles () {
            $("#uploadFileModal").modal("hide");
            this.previewFileUpload = true;
            this.num += 1;
        },
        goAddVoucher (data = "") {
            this.previewFileUpload = false;
            this.modeAdd = true;
            this.ocrData = data;
        },
        voucherSuccess (id) {
            this.reset();
            this.listVouchers();
            return this.detailContract(id);
        },
        successForceDelete (result) {
            this.reset();
            this.listVouchers();
            if (result.ok) {
                this.$toasted.success(result.msg, {});
            } else {
                this.$toasted.error(msg, {icon: 'fa-exclamation-triangle'});
            };
            return this.detailContract(result.id);
        },
        setVoucher () {
            this.$refs.addComponent.setVoucher();
        },

        showPreInputCopyModal () {
            this.$refs.preInputCopy.setPreInputList();
            $("#preInputCopyModal").modal("show");
        },
        // カメラアイコン end

        // タブメニュー切替
        switchScreen (screenType) {
            this.allReset();
            this.screenType = screenType;
            this.listVouchers(this.screenType);
            this.$router.push({path: '/voucher/contracts', query:{ screenType: screenType }});
        },

        reset () {
            this.errorMessage = "";
            this.voucherType = "";
            this.uploadFiles = [];
            this.previewFileUpload = false;
            this.num = 0;
            this.modeAdd = false;
            this.modeDetails = false;
            this.modeEdit = false;
        },

        allReset () {
            this.reset();

            this.condition = {};
            this.apply = {};
            this.under = {};
            this.schedule = {};
            this.item = {};
            this.pamphlet = {};
            this.bulk = {};
            this.contractId = "";
            this.isBulkOpened = false;
            this.isAloneOpened = false;
            this.isBulkShow = true;
            this.isAloneShow = true;
        },

        openToggle(type) {
            if (type == 1) {
                this.isBulkOpened = !this.isBulkOpened;
                if (this.isBulkOpened) {
                    this.isAloneOpened = false;
                }
            } else {
                this.isAloneOpened = !this.isAloneOpened;
                if (this.isAloneOpened) {
                    this.isBulkOpened = false;
                }
            }

        },
    },
    beforeDestroy () {
    },
    watch: {
        $route (to, from) {
            if (!Utils.isEmptyStr(to.query.screenType) && !Utils.isEmptyStr(from.query.screenType) && to.query.screenType != from.query.screenType) {
                this.screenType = to.query.screenType;
                this.listVouchers();
            }
        }
    },
};

</script>



// WEBPACK FOOTER //
// src/views/components/pc/Voucher/Contracts.vue